import { AiOutlineCamera } from 'react-icons/ai';
import { IoIosArrowRoundDown } from 'react-icons/io';
import MainPromotion from '../../../components/promotions/MainPromotion';
import { useNavigate } from 'react-router-dom';

type FairPricesPromotion = {
  t: (key: string) => string;
};
const FairPricesPromotion = ({ t }: FairPricesPromotion) => {
  const navigate = useNavigate();

  const startPriceRecord = () => {
    navigate('/price-record');
  };

  return (
    <div className="fair-prices-promotion overflow-hidden">
      <MainPromotion
        title={t('helpKeepPricesFair')}
        // subtitle="Help us keep the information up to date by reporting the prices you find."
        subtitle={t('helpKeepInformationUpdated')}
        // btnLabel="Report Price"
        btnLabel={t('reportPrice')}
        btnAction={startPriceRecord}
        btnIcon={<AiOutlineCamera />}
      >
        <div className="flex w-auto flex-col items-center px-12 py-10">
          {/* <p className="mb-8 w-full !text-start text-2xl font-bold">How to Report a Price</p> */}
          <p className="mb-8 w-full !text-start text-2xl font-bold">{t('howToReportPrice')}</p>
          <p className="w-full">
            {/* <span className="font-bold"> Step 1:</span> Upload photo of receipt or product with
            price */}
            <span className="font-bold mr-4"> {t('step1')}:</span> {t('step1Instruction')}
          </p>
          <IoIosArrowRoundDown className="text-4xl text-primary" />
          <p className="w-full">
            <span className="font-bold mr-4"> {t('step2')}:</span> {t('step2Instruction')}
          </p>
          <IoIosArrowRoundDown className="text-4xl text-primary" />
          <p className="w-full">
            <span className="font-bold mr-4"> {t('step3')}:</span> {t('step3Instruction')}
          </p>
        </div>
      </MainPromotion>
    </div>
  );
};

export default FairPricesPromotion;
